import type { FinanceStatus, Job } from '@kanda-libs/ks-frontend-services';
import type { ProgressStep } from 'components/ProgressIndicator';

export interface JobProgressCombination {
  status: NonNullable<Job['status']>;
  financeStatus: FinanceStatus;
}

export interface JobProgressStep {
  text: string;
  combinations: JobProgressCombination[];
}

export const STEPS: JobProgressStep[] = [
  {
    text: 'Sent',
    combinations: [
      {
        status: 'sent',
        financeStatus: 'not_applied',
      },
    ],
  },
  {
    text: 'Applied',
    combinations: [
      {
        status: 'sent',
        financeStatus: 'financed',
      },
      {
        status: 'sent',
        financeStatus: 'applied_for_finance',
      },
      {
        status: 'accepted',
        financeStatus: 'applied_for_finance',
      },
      {
        status: 'accepted',
        financeStatus: 'under_review',
      },
    ],
  },
  {
    text: 'Approved',
    combinations: [
      {
        status: 'accepted',
        financeStatus: 'financed',
      },
    ],
  },
  {
    text: 'Work Finished',
    combinations: [
      {
        status: 'accepted',
        financeStatus: 'payout_pending',
      },
      {
        status: 'accepted',
        financeStatus: 'sat_note_delayed',
      },
      {
        status: 'accepted',
        financeStatus: 'sat_note_lender_review',
      },
      {
        status: 'accepted',
        financeStatus: 'sat_note_sent',
      },
      {
        status: 'accepted',
        financeStatus: 'sat_note_signed',
      },
      {
        status: 'accepted',
        financeStatus: 'sat_note_viewed',
      },
      {
        status: 'finished',
        financeStatus: 'payout_pending',
      },
      {
        status: 'finished',
        financeStatus: 'sat_note_delayed',
      },
      {
        status: 'finished',
        financeStatus: 'sat_note_lender_review',
      },
      {
        status: 'finished',
        financeStatus: 'sat_note_sent',
      },
      {
        status: 'finished',
        financeStatus: 'sat_note_signed',
      },
      {
        status: 'finished',
        financeStatus: 'sat_note_viewed',
      },
    ],
  },
  {
    text: 'Paid',
    combinations: [
      {
        status: 'finished',
        financeStatus: 'paid',
      },
    ],
  },
];

export const DECLINED_NO_FINANCE_STEPS: ProgressStep[] = [
  {
    active: false,
    text: 'Sent',
  },
  {
    active: true,
    text: 'Job Declined',
  },
];

export const DECLINED_FINANCE_STEPS: ProgressStep[] = [
  {
    active: false,
    text: 'Sent',
  },
  {
    active: false,
    text: 'Applied',
  },
  {
    active: true,
    text: 'Declined for Finance',
  },
];

export const CANCELLED_FINANCE_STEPS: ProgressStep[] = [
  {
    active: false,
    text: 'Sent',
  },
  {
    active: false,
    text: 'Applied',
  },
  {
    active: true,
    text: 'Finance Cancelled',
  },
];

export const CHANGES_REQUESTED_STEPS: ProgressStep[] = [
  {
    active: true,
    text: 'Changes Requested',
  },
  {
    active: false,
    text: 'Applied',
  },
  {
    active: false,
    text: 'Approved',
  },
  {
    active: false,
    text: 'Work Finished',
  },
  {
    active: false,
    text: 'Paid',
  },
];
